import { createWithEqualityFn } from 'zustand/traditional'
import { addRelation } from 'api/relations'
import { PATHS } from 'types/enums'
import { RELATIONS } from 'types/enums'
import { NetworkStore } from 'types/store/networkStore'

const useStore = createWithEqualityFn<NetworkStore>(
	(set, get) => ({
		loading: false,
		setLoading: (loading) => set({ loading }),
		uploadedFile: null,
		setUploadedFile: (file) => set({ uploadedFile: file }),
		addContactsSidebar: {
			open: false,
			users: [],
		},
		setAddContactsSidebar: (data) =>
			set((state) => ({
				addContactsSidebar: { ...state.addContactsSidebar, ...data },
			})),
		setAddContact: (data) =>
			set((state) => ({
				addContactsSidebar: {
					...state.addContactsSidebar,
					users: [...state.addContactsSidebar.users, data],
				},
			})),
		parsedUsers: null,
		setParsedUsers: (user) => set({ parsedUsers: user }),
		openInviteUserSidebar: false,
		inviteAll: false,
		setOpenInviteUserSidebar: (open, inviteAll) =>
			set({ openInviteUserSidebar: open, inviteAll }),
		userProfile: {
			user: null,
			onUserChange: async (user) => {
				const { setUserProfile } = get()
				setUserProfile({ user })
				const role = window.location.pathname?.split('/')[1]

				if (user) {
					await addRelation({
						relation: RELATIONS.FAVCUSTOMER,
						targetId: user.ContentId,
						type: 'Customer',
					})

					return (
						`/${role}/${PATHS.NETWORK}/${user.ContentId}` + window.location.hash
					)
				} else {
					return `/${role}/${PATHS.NETWORK}` + window.location.hash
				}
			},
		},
		setUserProfile: (data) =>
			set((state) => ({
				userProfile: {
					...state.userProfile,
					...data,
				},
			})),
		acceptInviteToPoolSidebar: '',
		setAcceptInviteToPoolSidebar: (id) =>
			set({ acceptInviteToPoolSidebar: id }),
		networkRedirectionLink: '',
		setNetworkRedirectionLink: (link) => set({ networkRedirectionLink: link }),
	}),
	Object.is,
)

export default useStore
